import { AccountsRepo } from '@core/repositories'

const resource = "/accounts";

export default {

    fetch (config) {
        return AccountsRepo.get(`${resource}.json`, config)
    },
    usage (config,id) {
        return AccountsRepo.get(`accounts/${id}/billable_usage_reports.json`, config)
    },
    subscriptionDetails(id,config) {
        return AccountsRepo.get(`customers/${id}/customer_settings`, config)
    },
    fetchAccount(id, config) {
        return AccountsRepo.get(`${resource}/${id}.json`, config)
    },
    fetchAccountUsages(id, config) {
      return AccountsRepo.get(`${resource}/${id}/usage.json`, config)
    },
    fetchRequests(id, config) {
        return AccountsRepo.get(`accounts/${id}/requests.json`, config)
    },
    sendRequest(id,payload,config) {
      return AccountsRepo.post(`accounts/${id}/requests.json`,payload, config)
  }
}
